import { Injectable } from "@angular/core";
import { AuthenticationService } from "../authentication.service";
import {
  Http
} from "@angular/http";
import "rxjs/add/operator/map";
@Injectable()
export class ToolsService {

  constructor(private auth: AuthenticationService, private http: Http) { }

  //-------------------------GLCode Mapping-----------------------------------//
  Get_GLCodeMappingList(model: any) {

    return this.http
      .post(
        this.auth.baseUrl + "/services/api/tools/v1/Get_GLCodeMappingList",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Save_GLCodeMapping(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/tools/v1/Save_GLCodeMapping",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Get_GLCodeMappingById(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/tools/v1/Get_GLCodeMappingById",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });

  }

  //-------------------------GLCode Mapping-----------------------------------//
  //-------------------------Item Level-----------------------------------//
  Save_PublicItemLevel(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Save_PublicItemLevel",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_RestPublicItemLevelById(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_RestPublicItemLevelById",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_RestPublicItemLevelList(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_RestPublicItemLevelList",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Delete_PublicItemLevel(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Delete_PublicItemLevel",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //-------------------------Item Level-----------------------------------//
  //-------------------------Item Level Relation-----------------------------------//
  Save_PublicItemLevelRelation(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Save_PublicItemLevelRelation",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Update_PublicItemLevelRelation(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Update_PublicItemLevelRelation",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_RestPublicItemLevelRelationById(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_RestPublicItemLevelRelationById",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_RestPublicItemLevelRelationList(model: any) {
    return this.http
      .get(
        this.auth.baseUrl + "/services/api/rest/v1/Get_RestPublicItemLevelRelationList",
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Delete_PublicItemLevelRelation(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Delete_PublicItemLevelRelation",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //-------------------------Item Level Relation-----------------------------------//
  //------------------------Pickupmessage-----------------------------------//
  Get_RestPickUpMessage(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_RestPickUpMessage",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_RestPickUpMessageById(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_RestPickUpMessageById",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  SaveUpdate_RestPickUpMessage(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/SaveUpdate_RestPickUpMessage",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Delete_RestPickUpMessage(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Delete_RestPickUpMessage",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //------------------------Pickupmessage-----------------------------------//
  //------------------------Mail Log--------------------------------------//
  Get_MailLog(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/tools/v1/Get_MailLog",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Resend_MailFromLog(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/tools/v1/Resend_MailFromLog",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //------------------------Mail Log--------------------------------------//
 //------------------------PriceChange--------------------------------
 Get_ItemsForToolsPriceChange(model: any) {
  return this.http
    .post(
      this.auth.baseUrl + "/services/api/rest/v1/Get_ItemsForToolsPriceChange", model,
      this.auth.getHeader()
    )
    .map(res => {
      return res.json();
    });
}

Update_ToolsSellingPrice(model: any) {
  return this.http
    .post(
      this.auth.baseUrl + "/services/api/rest/v1/Update_ToolsSellingPrice", model,
      this.auth.getHeader()
    )
    .map(res => {
      return res.json();
    });
}

Get_CategoryForPriceChange(model: any) {
  return this.http
    .post(
      this.auth.baseUrl + "/services/api/rest/v1/Get_CategoryForPriceChange", model,
      this.auth.getHeader()
    )
    .map(res => {
      return res.json();
    });
}

//------------------------PriceChange--------------------------------
//------------------------Price Level--------------------------------
Get_ToolsSellingPriceLevel(model:any){
  return this.http
  .post(
    this.auth.baseUrl + "/services/api/rest/v1/Get_ToolsSellingPriceLevel", model,
    this.auth.getHeader()
  )
  .map(res => {
    return res.json();
  });
}

Save_ToolsSellingPriceLevel(model:any){
  return this.http
  .post(
    this.auth.baseUrl + "/services/api/rest/v1/Save_ToolsSellingPriceLevel", model,
    this.auth.getHeader()
  )
  .map(res => {
    return res.json();
  });
}

Delete_ToolsSellingPriceLevel(model:any){
  return this.http
  .post(
    this.auth.baseUrl + "/services/api/rest/v1/Delete_ToolsSellingPriceLevel", model,
    this.auth.getHeader()
  )
  .map(res => {
    return res.json();
  });
}

//------------------------Price Level--------------------------------
//------------------------Price Level MApping--------------------------------
Get_ToolsPriceLevelForPriceMapping(model:any){
  return this.http
  .post(
    this.auth.baseUrl + "/services/api/rest/v1/Get_ToolsPriceLevelForPriceMapping", model,
    this.auth.getHeader()
  )
  .map(res => {
    return res.json();
  });
}

Get_ToolsPriceLocationMapping(model:any){
  return this.http
  .post(
    this.auth.baseUrl + "/services/api/rest/v1/Get_ToolsPriceLocationMapping", model,
    this.auth.getHeader()
  )
  .map(res => {
    return res.json();
  });
}

Update_ToolsPriceLocationMapping(model:any){
  return this.http
  .post(
    this.auth.baseUrl + "/services/api/rest/v1/Update_ToolsPriceLocationMapping", model,
    this.auth.getHeader()
  )
  .map(res => {
    return res.json();
  });
}
//------------------------Price Level Mapping--------------------------------

}





// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/services/tools/tools.service.ts